import { z } from 'zod';
export const renderReportSchema = z.object({
    width: z.number(),
    height: z.number(),
    overflow: z.array(z.object({ selector: z.string(), by: z.number() })),
    emptyBindings: z.array(z.string()),
    failedImages: z.array(z.string()),
    chartErrors: z.array(z.object({ dataset: z.string(), message: z.string() })),
    removed: z.array(z.string()),
});
